.modalContentAgeGate {
  max-width: 279px;
  margin: 13px 24px 24px;
}

.modalContentBirthDate {
  max-width: 279px;
  margin: 24px;
}
